/* @ngInject */
const phone = (
  phoneAsk,
  phoneRequest
) => {
  const self = {}

  self.new = () => {
    return {
      id: null,
      number: null,
      contactId: null,
    }
  }

  self.ask = phoneAsk
  self.request = phoneRequest

  return self
}

export default phone



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/services/phone.service.js